'use strict';

angular.module('requireCompleteSignIn', [])
.controller('requireCompleteSignInController', require('./requireCompleteSignInController'))
.directive('requireCompleteSignIn', require('./requireCompleteSignInDirective'));



// WEBPACK FOOTER //
// ./src/app/requireCompleteSignIn/index.js